import { render, staticRenderFns } from "./debug_tab_presentation.vue?vue&type=template&id=70c42d43&"
import script from "./debug_tab_presentation.vue?vue&type=script&lang=js&"
export * from "./debug_tab_presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260908145540/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c42d43')) {
      api.createRecord('70c42d43', component.options)
    } else {
      api.reload('70c42d43', component.options)
    }
    module.hot.accept("./debug_tab_presentation.vue?vue&type=template&id=70c42d43&", function () {
      api.rerender('70c42d43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/debug/debug_tab_presentation.vue"
export default component.exports